import { TableColumn as ElTableColumn } from 'element-ui'

import { importAll } from '../../../utils'

const extendColumnType = {}
const columnTypeFromDir = require.context('./extend-column-type', false, /.js$/)
const isRequired = required => required === '' || required === true

importAll(extendColumnType, columnTypeFromDir)

export default {
  functional: true,
  name: 'TableColumn',
  render(h, ctx) {
    const { props, data } = ctx

    if (!data.scopedSlots) data.scopedSlots = {}
    if (!data.attrs) data.attrs = {}

    // 如果没有传入默认插槽并配置了renderColumn 则使用renderColumn来渲染插槽
    if (props.renderColumn && !data.scopedSlots.default) {
      data.scopedSlots.default = scope => {
        return props.renderColumn(h, scope, ctx)
      }
    }

    // 如果没有传入表头插槽并配置了renderHeader 则使用renderHeader来渲染表头
    if (props.renderHeader && data.scopedSlots.header) {
      data.scopedSlots.header = scope => {
        return props.renderHeader(h, scope, ctx)
      }
    }

    const columnType = props.type
    const extendConfig = extendColumnType[columnType]

    // 如果类型为自定义类型
    if (extendConfig) {
      const { defaultCellProps, renderCell } = extendConfig

      // 设置默认属性
      data.attrs = Object.assign({}, defaultCellProps, data.attrs)

      // 如果没有传作用域插槽，则调用默认的扩展类型 renderCell
      if (!data.scopedSlots.default) {
        data.scopedSlots.default = scope => {
          const pagodaTable = scope._self

          return renderCell(h, scope, pagodaTable)
        }
      }
    }

    // required
    if (isRequired(props.required)) {
      const requireClass = 'column-required'
      const classes = data.attrs.labelClassName

      data.attrs.labelClassName = classes ? `${classes} ${requireClass}` : requireClass
    }

    return <ElTableColumn {...ctx.data}>{ctx.children}</ElTableColumn>
  }
}
